import type { RouteObject } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import Home from "@/pages/home/page";
import Category from "@/pages/category/page";
import Detail from "@/pages/detail/page";
import NewsList from "@/pages/news/page";
import NewsDetail from "@/pages/news/detail/page";
import Search from "@/pages/search/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    element: <SiteLayout />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/category/:type", element: <Category /> },
      { path: "/detail/:id", element: <Detail /> },
      { path: "/news", element: <NewsList /> },
      { path: "/news/:id", element: <NewsDetail /> },
      { path: "/search", element: <Search /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;